// PROMPT 4 PART 1: shared helpers for using the Storyteller's name across the UI.
// If the account has no storyteller yet, we fall back to gentle generic copy.

export function storytellerDisplayName(user) {
  const st = user?.storyteller;
  if (!st) return null;
  if (st.self_story) return st.first_name || user?.name?.split(" ")[0] || "you";
  // Prefer the personalised call_name ("Nanna", "Granny Jean") if the user set it,
  // otherwise fall back to the relationship label, then the first name.
  if (st.call_name && st.call_name.trim()) return st.call_name.trim();
  const relLabels = { Nan: "Nan", Grandad: "Grandad", Grandma: "Grandma", Grandpa: "Grandpa",
                      Mum: "Mum", Dad: "Dad", Sister: "Sister", Brother: "Brother", Partner: "Partner" };
  return relLabels[st.relationship] || st.first_name || st.relationship || "them";
}

// For sentences like "Today's question for Nan" or "Sunday question for Margaret"
export function forStoryteller(user, fallback = "them") {
  const name = storytellerDisplayName(user);
  return name || fallback;
}

// Possessive: "Nan's Living Book" / "Margaret's Living Book"
export function storytellerPossessive(user, fallback = "your") {
  const name = storytellerDisplayName(user);
  if (!name) return fallback;
  if (name.endsWith("s")) return `${name}'`;
  return `${name}'s`;
}

// Book-cover formal name: "Margaret · of the Hartley family"
export function coverName(user) {
  const st = user?.storyteller;
  if (!st) return null;
  const first = st.first_name?.trim();
  const surname = st.surname?.trim();
  if (!first) return null;
  if (!surname) return first;
  return `${first} · of the ${surname} family`;
}
